import '../../styles/restScreens.css';
import React from 'react';
import ProgressBar from './ProgressBar';

const STATUS_COLORS = {
  Queue: { light: 'bg-gray-100 text-gray-700', dark: 'bg-gray-700 text-gray-200' },
  'In Progress': { light: 'bg-blue-100 text-blue-700', dark: 'bg-blue-900 text-blue-300' },
  Blocked: { light: 'bg-red-100 text-red-700', dark: 'bg-red-900 text-red-300' },
  Completed: { light: 'bg-green-100 text-green-700', dark: 'bg-green-900 text-green-300' },
  Cancelled: { light: 'bg-gray-100 text-gray-500 line-through', dark: 'bg-gray-700 text-gray-500 line-through' },
};

const PRIORITY_COLORS = {
  Critical: { light: 'bg-red-50 text-red-700', dark: 'bg-red-900/50 text-red-300' },
  Urgent: { light: 'bg-[var(--ui-moderate)]/10 text-[var(--ui-moderate)]', dark: 'bg-[var(--ui-moderate)]/20 text-[var(--ui-moderate)]' },
  Important: { light: 'bg-amber-50 text-amber-700', dark: 'bg-amber-900/50 text-amber-300' },
  Normal: { light: 'bg-gray-50 text-gray-600', dark: 'bg-gray-700 text-gray-300' },
  Low: { light: 'bg-gray-50 text-gray-500', dark: 'bg-gray-700 text-gray-400' },
};

export default function TaskCard({ task, theme = 'light', onClick }) {
  const statusColor = STATUS_COLORS[task.status] || STATUS_COLORS.Queue;
  const priorityColor = PRIORITY_COLORS[task.priority] || PRIORITY_COLORS.Normal;
  const mode = theme === 'dark' ? 'dark' : 'light';

  return (
    <div data-m6-layout="tasks" data-m6-component="TaskCard"
      onClick={onClick}
      className={`rounded-lg border p-3 cursor-pointer transition-shadow hover:shadow-md ${
        theme === 'dark' ? 'bg-gray-800 border-gray-700 hover:border-[var(--accent-ink)]' : 'bg-white border-gray-200 hover:border-[var(--accent-ink)]'
      }`}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <h4 className={`text-sm font-semibold leading-snug ${theme === 'dark' ? 'text-gray-100' : 'text-gray-800'}`}>
          {task.task_name}
        </h4>
        {task.flag && task.flag !== 'None' && (
          <span className="text-xs shrink-0" title={task.flag}>
            {task.flag === 'Blocked' ? '🚫' : '⏸️'}
          </span>
        )}
      </div>

      <div className="flex flex-wrap gap-1.5 mb-2">
        <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${statusColor[mode]}`}>{task.status}</span>
        {task.priority && (
          <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${priorityColor[mode]}`}>{task.priority}</span>
        )}
      </div>

      <ProgressBar progressPct={task.progress_pct} theme={theme} showLabel={false} size="sm" />

      <div className={`flex items-center justify-between mt-2 text-xs ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
        <span>{task.workspace_tag}</span>
        {task.due_date && <span>Due {task.due_date}</span>}
      </div>
    </div>
  );
}
